var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSara = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C12 7.29899 16.701 12 22.5 12C16.701 12 12 16.701 12 22.5C12 16.701 7.29899 12 1.5 12C7.29899 12 12 7.29899 12 1.5Z",
    fill: "url(#paint0_linear_4001_8109)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C12 7.29899 16.701 12 22.5 12C16.701 12 12 16.701 12 22.5C12 16.701 7.29899 12 1.5 12C7.29899 12 12 7.29899 12 1.5Z",
    fill: "url(#paint1_linear_4001_8109)",
    fillOpacity: 0.24
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4001_8109",
    x1: 5.15625,
    y1: 3.65625,
    x2: 18.6094,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81F76",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5324"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4001_8109",
    x1: 13.9688,
    y1: 16.2656,
    x2: 18.8906,
    y2: 23.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC208",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC208"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSara);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Sara.7436bc8bde6cf1b95f9d439c7a513b7e.svg";